/** 小書きカナ → 通常カナ（カタカナ・ひらがな） */
const SMALL_TO_REGULAR_KANA: Readonly<Record<string, string>> = {
  ァ: 'ア',
  ィ: 'イ',
  ゥ: 'ウ',
  ェ: 'エ',
  ォ: 'オ',
  ッ: 'ツ',
  ャ: 'ヤ',
  ュ: 'ユ',
  ョ: 'ヨ',
  ヮ: 'ワ',
  ヵ: 'カ',
  ヶ: 'ケ',
  ぁ: 'あ',
  ぃ: 'い',
  ぅ: 'う',
  ぇ: 'え',
  ぉ: 'お',
  っ: 'つ',
  ゃ: 'や',
  ゅ: 'ゆ',
  ょ: 'よ',
  ゎ: 'わ',
  ゕ: 'か',
  ゖ: 'け',
};

/**
 * カナ文字列を正規化する。
 * 1. NFKC（互換文字・半角カナ→全角など）
 * 2. 小書き→通常（例: ョ→ヨ, ッ→ツ）
 */
export const normalizeKana = (value: string): string => {
  const nfkc = value.normalize('NFKC');
  return [...nfkc].map((ch) => SMALL_TO_REGULAR_KANA[ch] ?? ch).join('');
};
